var exports = {
  "kR": "AssetSourceModal.module__cards___cXpPLU",
  "KI": "AssetSourceModal.module__cardsSingle___cXpPLU",
  "Nr": "AssetSourceModal.module__card___cXpPLU",
  "Ie": "AssetSourceModal.module__cardIcon___cXpPLU",
  "PY": "AssetSourceModal.module__cardLabel___cXpPLU",
  "eX": "AssetSourceModal.module__cardHint___cXpPLU",
};

module.exports = exports;
